import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

// Using a placeholder or environment variable for the Measurement ID
const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || "G-XXXXXXXXXX";

export const GATracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4
    ReactGA.initialize(MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    // Send pageview on route change
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  useEffect(() => {
    const handleGlobalClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      // Traverse up to find a button if the click was on a child element
      const button = target.closest("button");

      if (button) {
        // Try to get a meaningful label for the button
        const label = button.innerText || button.getAttribute("aria-label") || button.id || "Unknown Button";

        ReactGA.event({
          category: "User Interaction",
          action: "Button Click",
          label: label.substring(0, 100), // Limit label length
        });
      }
    };

    window.addEventListener("click", handleGlobalClick);

    return () => {
      window.removeEventListener("click", handleGlobalClick);
    };
  }, []);

  return null;
};
